import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import en from 'vuetify/es5/locale/en';
import fr from 'vuetify/es5/locale/fr';

import themes from './theme';


Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    options: {
      customProperties: true
    },
    themes
  },
  lang: {
    locales: { en, fr },
    current: 'fr'
  },
  icons: {
    iconfont: 'md'
  }
});
